/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Alert, Box, Button, IconButton,
  LinearProgress, MenuItem, Pagination, Select, Snackbar, Tab, Tabs, TextField,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  BorderColorRounded, ExpandMoreRounded, Search, VisibilityOutlined,
} from '@mui/icons-material';
import moment from 'moment';
import Elements from '../../../Elements';
import { getCourier } from '../../../../Redux/Models/courier';
import ROUTES from '../../../../Configs/routes';
import { getRequestStatus } from '../../../../Redux/Models/master';
// import ROUTES from '../../../../Configs/routes';

export default function Couriers({
  classes, couriers, totalPage = 1, isLoading = false, currentPage = 1,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { devId } = useParams();

  const { requestStatus } = useSelector((state) => state.master);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [keyword, setKeyword] = useState('');
  const [reqStatus, setStatus] = useState('all');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [type, setType] = useState('All Courier');
  const [sort, setSort] = useState('Newest');

  useEffect(() => {
    dispatch(getRequestStatus());
  }, []);

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getData = () => {
    dispatch(getCourier({
      limit, page, status: reqStatus === 'all' ? '' : reqStatus, sort, keyword,
    }));
  };

  useEffect(() => {
    getData();
  }, [limit, page, reqStatus, sort]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (page === 1) {
        getData();
      } else {
        setPage(1);
      }
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [keyword]);

  return (
    <Elements.AdminPageBase navigate={navigate}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <div>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box fontSize={20}>
              <strong>Courier</strong>
            </Box>
            <Box>
              <Button
                onClick={() => navigate(`${ROUTES.couriers()}/create`)}
                className="btn-contained"
                sx={{ px: 3, fontSize: 14 }}
                size="small"
                fullWidth
              >
                Add New Courier
              </Button>
            </Box>
          </Box>

          <Box bgcolor="#FDFDFD" borderRadius="10px" pb={1} px={1} mt={2}>
            <Tabs value={type} className={`${classes.tabs}`} onChange={(e, newType) => setType(newType)}>
              <Tab
                label={(
                  <Box display="flex" gap={1.5} alignItems="center">
                    All Courier
                  </Box>
              )}
                value="All Courier"
                disableRipple
              />
              <Tab
                label={(
                  <Box display="flex" gap={1.5} alignItems="center">
                    Courier History
                  </Box>
              )}
                value="Courier History"
                disableRipple
              />
            </Tabs>
          </Box>

          <Box mt={2} className="flex gap-16 space-between">
            <Box display="flex" gap={1}>
              <Select
                select
                size="small"
                value={sort}
                onChange={({ target }) => setSort(target.value)}
                IconComponent={ExpandMoreRounded}
                sx={{
                  borderRadius: '10px',
                  bgcolor: '#fff',
                }}
              >
                <MenuItem value="Oldest">Oldest</MenuItem>
                <MenuItem value="Newest">Newest</MenuItem>
              </Select>
              <Select
                select
                value={reqStatus}
                size="small"
                onChange={({ target }) => setStatus(target.value)}
                IconComponent={ExpandMoreRounded}
                sx={{
                  borderRadius: '10px',
                  bgcolor: '#fff',
                }}
              >
                <MenuItem value="all">All status</MenuItem>
                {requestStatus.map((s) => (
                  <MenuItem value={s} key={s}>{s}</MenuItem>
                ))}
              </Select>
            </Box>
            <Box display="flex" gap={2}>
              <Select
                select
                size="small"
                value={limit}
                onChange={({ target }) => setLimit(target.value)}
                IconComponent={ExpandMoreRounded}
                sx={{
                  borderRadius: '10px',
                  bgcolor: '#fff',
                }}
              >
                <MenuItem value={10}>10 List</MenuItem>
                <MenuItem value={20}>20 List</MenuItem>
                <MenuItem value={50}>50 List</MenuItem>
              </Select>
              <TextField
                placeholder="Search by keyword"
                size="small"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                sx={{
                  ' .MuiInputBase-root': {
                    bgcolor: '#fff',
                  },
                }}
                InputProps={{
                  startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
                }}
              />
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-between" mt={2}>
            <Box fontSize={12} color="#586479">
              <strong>{couriers.length}</strong>
              {' '}
              total request order
            </Box>
            <Pagination
              count={totalPage}
              variant="outlined"
              shape="rounded"
              size="small"
              page={!isLoading ? currentPage : page}
              siblingCount={0}
              onChange={(e, newPage) => setPage(newPage)}
            />
          </Box>
        </div>

        {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}

        <div className="mt-3">
          <table>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Courier ID</td>
                <td className="white">Order ID</td>
                <td className="white">Status</td>
                <td className="white">Service</td>
                <td className="white">Order Date</td>
                <td className="white">Name</td>
                <td className="white">Destination</td>
              </tr>
            </thead>
            <tbody>
              {couriers.map((courier) => (
                <tr key={courier.courier?.id}>
                  <td>
                    <Link to={`${ROUTES.couriers()}/detail/${courier.courier?.id}`} className="primary-green">
                      {courier.courier?.id?.slice(0, 5)}
                      ...
                    </Link>
                  </td>
                  <td>
                    {courier.order
                      ? (
                        <Link to={`${courier.service === 'Request Out' ? ROUTES.requestOut() : ROUTES.requestIn()}/${courier.order?.id}`} className="primary-green">
                          {courier.order?.id?.slice(0, 5)}
                          ...
                        </Link>
                      )
                      : '-'}
                  </td>
                  <td>
                    {courier.status && courier.status !== 'Done' && courier.status !== 'AVAILABLE'
                      ? (
                        <Box
                          bgcolor="#D9EDFC"
                          display="inline-flex"
                          fontSize={12}
                          fontWeight="700"
                          color="#2391D9"
                          py="2px"
                          px={1}
                          borderRadius="4px"
                        >
                          {courier.status}
                        </Box>
                      )
                      : (
                        <Box
                          bgcolor="#DBF9DB"
                          display="inline-flex"
                          fontSize={12}
                          fontWeight="700"
                          color="#38AC3D"
                          py="2px"
                          px={1}
                          borderRadius="4px"
                        >
                          Available
                        </Box>
                      )}
                  </td>
                  <td>{courier.service}</td>
                  <td>{courier.order_date ? moment(courier.order_date).format('DD MMM YYYY, HH.mm') : '-'}</td>
                  <td>{courier.courier_name}</td>
                  <td>{courier.destination || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </Elements.AdminPageBase>
  );
}
